// extracted by mini-css-extract-plugin
module.exports = {"card":"TypeCard-module__card___2b9dn","beta":"TypeCard-module__beta___26dOG","text":"TypeCard-module__text___3VVf2"};